import {environment} from 'src/environments/environment';
import {Component, Input, OnInit} from '@angular/core';


export type IPanelModes = 'default' | 'chapterList' | 'carousel';

@Component({
  selector: 'app-panel',
  templateUrl: './panel.component.html',
  styleUrls: ['./panel.component.scss']
})
export class PanelComponent implements OnInit {
  @Input() questionaryId!: any
  @Input() chapter!: any
  @Input() mode: IPanelModes = 'default'
  @Input() alternativeMode = false
  @Input() chapterNumber!: number;
  @Input() isCarousel!: boolean;
  @Input() userSubscribed!: boolean;
  @Input() enable = true;
  @Input() circleProgressOption: any = {
    radius: 50,
    space: -10,
    outerStrokeGradient: true,
    outerStrokeWidth: 10,
    outerStrokeColor: "#fff",
    innerStrokeColor: "rgba(255,255,255, .5)",
    innerStrokeWidth: 10,
    animationDuration: 1000,
    animation: false,
    showBackground: false,
    clockwise: true,
    startFromZero: false,
    lazy: false,
    titleColor: '#fff',
    unitsColor: '#fff',
    unitsFontSize: '14px',
    titleFontWeight: 'bold',
    showSubtitle: false,
  }
  apiUrl = environment.apiUrl

  constructor() {
  }

  ngOnInit(): void {
  }

  isChapterCompleted(chapter: any) {
    return chapter.progress.progress_percentage === 100
  }

  dynamicStyles(chapter: any) {
    const styles = {
      'background-color': '#006EE9',
      'background-image': `url(${chapter.image})`,
      'background': `transparent linear-gradient(140deg, ${chapter.background_color} 0%, ${chapter.gradient_color} 100%) 0% 0%`,
    }
    styles.background = !chapter.image ? `transparent linear-gradient(140deg, ${chapter.background_color} 0%, ${chapter.gradient_color} 100%) 0% 0%` : `url(${chapter.image}) center cover no-repeat`
    return styles
  }
}
